import React, { use, useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import ConfirmationPopupProviderContext from 'shared/components/confirmation-pop-up/providers/contexts/confirmation-popup-provider-context';

const ConfirmationPopUpGuard = (): React.JSX.Element => {
  const { shouldPopUp, showDefaultConfirmationPopUp } = use(ConfirmationPopupProviderContext);

  const blocker = useBlocker(shouldPopUp);

  useEffect(() => {
    if (shouldPopUp) {
      showDefaultConfirmationPopUp({
        action: () => {
          if (blocker.state === 'blocked') {
            blocker.proceed();
            blocker.reset();
          }
        },
      });
    } else if (blocker.proceed && blocker.state === 'blocked') {
      blocker.proceed();
      blocker.reset();
    }
  }, [blocker]);

  return <></>;
};

export default ConfirmationPopUpGuard;
